import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import ScrollToTop from './components/shared/ScrollToTop'
import Navbar from './components/layout/Navbar'
import Footer from './components/layout/Footer'
import Home from './pages/Home'
import Features from './pages/Features'
import Platform from './pages/Platform'
import Pricing from './pages/Pricing'
import About from './pages/About'
import Demo from './pages/Demo'
import Contact from './pages/Contact'
import SignIn from './pages/SignIn'
import Register from './pages/Register'
import PaymentSuccess from './pages/PaymentSuccess'
import PaymentCancel from './pages/PaymentCancel'
import Blog from './pages/Blog'
import BlogPost from './pages/BlogPost'
import Careers from './pages/Careers'
import Documentation from './pages/Documentation'
import APIReference from './pages/APIReference'
import Status from './pages/Status'
import Support from './pages/Support'
import Privacy from './pages/Privacy'
import SensorBox from './pages/SensorBox'
import Terms from './pages/Terms'
import Cookies from './pages/Cookies'

function App() {
  return (
    <AuthProvider>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/platform" element={<Platform />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about" element={<About />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/register" element={<Register />} />
          <Route path="/register/success" element={<PaymentSuccess />} />
          <Route path="/register/cancel" element={<PaymentCancel />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/docs" element={<Documentation />} />
          <Route path="/api" element={<APIReference />} />
          <Route path="/status" element={<Status />} />
          <Route path="/support" element={<Support />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/sensor-box" element={<SensorBox />} />
        </Routes>
      </main>
      <Footer />
    </AuthProvider>
  )
}

export default App
